import { action, computed, observable, makeObservable } from 'mobx';
import type { MaterialIcon } from '../../components/icon/icons';
import type { T } from '../../i18n';
import type { IkePageName } from '../../page/page';
import { PageRegistry } from '../../page/page.registry';
import { Services } from '../../services';

export interface NavDrawerEntry {
	type: string | 'external' | 'internal';
	name: IkePageName;
	title: T;
	icon: MaterialIcon;
	current?: boolean;
}

export class NavDrawerCtrl {
	@observable visible: boolean = false;

	constructor() {
		makeObservable(this);
	}

	@computed get entries(): NavDrawerEntry[] {
		const entries: NavDrawerEntry[] = [];
		for (const { config } of PageRegistry.pages) {
			if (config.nav == null) {
				continue;
			}

			const currentUser = Services.User.current;
			const userProfile = currentUser ? Services.UserProfile.get(currentUser.objectId) : null;

			if (
				(config.auth.tokens == null || Services.Token.hasAll(config.auth.tokens)) &&
				(config.auth.userLevel == null || Services.UserProfile.isOneOf(userProfile, config.auth.userLevel))
			) {
				entries.push({
					type: config.type,
					title: config.nav.name,
					icon: config.nav.icon,
					name: config.name,
					current: Services.Route.active.config.name === config.name,
				});
			}
		}

		return entries;
	}

	@computed get username(): string {
		const user = Services.User.current;
		if (user != null) {
			return Services.User.current.username;
		}

		return '';
	}

	@action setVisible(visible: boolean) {
		this.visible = visible;
	}
}
